import {getBaseUrl} from './utils';
import {FooterConfig, GetConfigParams} from '../shared';
import {AgentGraphicIcon, HospitalGraphicIcon, ProfileSystemIcon} from '@nib/icons';

const CORPORATE_PHONE_NUMBER = '1800 249 966';
const LINKED_IN_URL = 'https://au.linkedin.com/company/gu-health';
const ABSOLUTE_BASEURL = 'https://www.guhealth.com.au';

interface SocialMediaLink {
  id: string;
  title: string;
  url: string;
  key: string;
}

const linkedIn: SocialMediaLink = {
  key: 'LinkedIn',
  id: 'ga-footer-gu-linked-in',
  title: 'Follow GU on Linked In',
  url: LINKED_IN_URL
};

const getGuConfig = (config: GetConfigParams): FooterConfig => {
  const baseUrl = getBaseUrl(config, ABSOLUTE_BASEURL);
  return {
    id: 'footer-gu',
    columns: [
      {
        id: 'ga-footer-gu-forms',
        title: 'Forms',
        children: [
          {
            id: 'ga-footer-gu-make-claim',
            title: 'Make a claim form',
            url: `${baseUrl}docs/gu-make-a-claim-form`
          },
          {
            id: 'ga-footer-gu-student-dependent-form',
            title: 'Register a student dependent form',
            url: `${baseUrl}docs/register-student-dependant-form`
          },
          {
            id: 'ga-footer-gu-fastback-form',
            title: 'FastBack form',
            url: `${baseUrl}docs/nominate-acc-fastback-payment-form`
          },
          {
            id: 'ga-footer-gu-medical-gap-network',
            title: 'GU Health Medical Gap Network Provider Registration',
            url: `https://register.honeysucklehealth.com.au/for-providers/medical-network-registration/`
          },
          {
            id: 'ga-footer-gu-other-forms',
            title: 'Other forms',
            url: `${baseUrl}factsheets-and-forms`
          }
        ]
      },
      {
        id: 'ga-footer-gu-quick-links',
        title: 'Quick links',
        children: [
          {
            id: 'ga-footer-gu-about-us',
            title: 'About GU Health',
            url: `${baseUrl}about-us`
          },
          {
            id: 'ga-footer-gu-find-a-provider',
            title: 'Find a provider',
            url: `${baseUrl}find-a-provider/`
          },
          {
            id: 'ga-footer-gu-information-for-providers',
            title: 'Information for providers',
            url: `${baseUrl}for-providers`,
            targetBlank: true
          },
          {
            id: 'ga-footer-gu-health-app',
            title: 'GU Health App',
            url: `${baseUrl}mobile-apps`
          },
          {
            id: 'ga-footer-gu-how-to-claim',
            title: 'How to claim',
            url: `${baseUrl}how-to-claim`
          }
        ]
      }
    ],
    contact: {
      heading: 'Get in touch',
      phoneNumber: CORPORATE_PHONE_NUMBER,
      contactLinks: [
        {
          id: 'ga-footer-gu-member-login',
          title: 'Member login',
          url: `https://members.guhealth.com.au/Member/Account/Login `,
          icon: ProfileSystemIcon
        },
        {
          id: 'ga-footer-gu-hr-login',
          title: 'HR login',
          url: `https://members.guhealth.com.au/Hr/Account/HrLogin`,
          icon: AgentGraphicIcon
        },
        {
          id: 'ga-footer-gu-hospital-login',
          title: 'Hospital login',
          url: `https://members.guhealth.com.au/provider/`,
          icon: HospitalGraphicIcon
        }
      ],
      socialLinks: [linkedIn]
    },
    smallFooterConfig: {
      id: 'small-footer-gu',
      copyrightText: `Copyright © ${new Date().getFullYear()} nib health funds limited ABN 83 000 124 381`,
      phoneNumber: CORPORATE_PHONE_NUMBER,
      corporatePhoneNumber: CORPORATE_PHONE_NUMBER,
      links: [
        {
          id: 'ga-footer-gu-fund-rules',
          title: 'Fund Rules',
          url: `${baseUrl}docs/fund-rules`
        },
        {
          id: 'ga-footer-gu-terms',
          title: 'Terms & Conditions',
          url: `${baseUrl}terms-and-conditions`,
          targetBlank: true
        },
        {
          id: 'ga-footer-gu-privacy',
          title: 'Privacy Policy',
          url: `${baseUrl}docs/gu-health-privacy-policy`
        },
        {
          id: 'ga-footer-gu-code-conduct',
          title: 'Code of Conduct',
          url: 'http://privatehealth.com.au/codeofconduct'
        }
      ]
    }
  };
};

export default getGuConfig;
